import { LOGIN_COPY, LOGIN_NAV_ITEMS } from '../constants/loginContent'
import StatusBridge from './StatusBridge'

export default function LoginSidebar() {
  return (
    <aside className="hidden w-80 shrink-0 flex-col bg-surface-container-low px-10 py-12 lg:flex sticky top-0 h-screen overflow-y-auto">
      <div className="mb-12">
        <p className="font-headline text-xl font-black text-primary">{LOGIN_COPY.brand}</p>
        <p className="mt-1 text-xs text-secondary">{LOGIN_COPY.tagline}</p>
      </div>

      <nav className="space-y-6" aria-label="Login Navigation">
        {LOGIN_NAV_ITEMS.map((item) => (
          <div
            key={item.label}
            className={`flex items-center gap-4 text-sm font-semibold ${
              item.active ? 'text-primary' : 'text-secondary'
            }`}
          >
            <span className="material-symbols-outlined text-[18px]" aria-hidden="true">
              {item.icon}
            </span>
            <span className="font-label">{item.label}</span>
          </div>
        ))}
      </nav>

      <StatusBridge progress={33} label={LOGIN_COPY.readinessLabel} className="mt-auto" />
    </aside>
  )
}
